import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  AuthorizeResponse,
  CompleteAuthorizationRequest,
  CheckCurrencyConversionRequest,
} from '@shared/stripe/models';
import { ApiClientService } from '../api-client.service';

@Injectable({ providedIn: 'root' })
export class StripeService {
  private readonly basePath = '/v.1/stripe';

  constructor(private readonly http: ApiClientService) { }

  authorize(): Observable<AuthorizeResponse> {
    return this.http.post<{ url: string }>(`${this.basePath}/authorize`, {});
  }

  complete(data: CompleteAuthorizationRequest): Observable<void> {
    return this.http.post(`${this.basePath}/complete`, data);
  }

  updateIntegration(data: { enabled: boolean; currency?: string }): Observable<void> {
    return this.http.post(`${this.basePath}/update-integration`, data);
  }

  checkCurrencyConversion(data: CheckCurrencyConversionRequest): Observable<number> {
    return this.http.post<number>(`${this.basePath}/currency/convert`, data);
  }
}
